import React, { useContext } from 'react';
import { context } from '@catalogo/ui-americanas-desktop-product-review/src/context';
import { Title, Text, NoReviewsStyled } from './Styled';
import { Anchor } from '../../atoms';

const NoReview = () => {
  const { config, dispatchMetrics } = useContext<any>(context);
  const { productId } = config;
  const href = `/avaliacao/${productId}`;

  return (
    <NoReviewsStyled className="product-review-no-review">
      <Title className="product-review-no-review-title">esse produto ainda não tem avaliações</Title>
      <Text className="product-review-no-review-text">Ajude outras pessoas e faça a primeira :)</Text>
      <Anchor
        onClick={() => {
          dispatchMetrics('event:track', {
            category: 'avaliacao-pdp',
            action: 'primeira-avaliacao',
            label: `area-avaliacao`,
          });
        }}
        href={href}
      >
        avaliar produto
      </Anchor>
    </NoReviewsStyled>
  );
};
export default NoReview;
export { NoReview };
